import type { FunctionComponent } from 'react';

import { Card, Stack, Text } from '@mantine/core';

import HoursLine from 'components/MenuManagement/MenuPreview/HoursLine';
import type { MenuDayHours } from 'types/menuHours';

type HoursCardProps = {
  hours: MenuDayHours[];
  label: string;
  testId: string;
  /** `dayIndex` of the current day, tagged "(Today)" in the list. */
  today: string;
};

export const HoursCard: FunctionComponent<HoursCardProps> = ({ hours, label, testId, today }) => (
  <Card data-testid={testId} bd="1px solid var(--border-secondary)">
    <Stack>
      <Text variant="body-sm-bold">{label}</Text>
      {hours.map(dayHours => (
        <HoursLine
          key={dayHours.dayIndex}
          hoursData={dayHours}
          showToday={dayHours.dayIndex === today}
        />
      ))}
    </Stack>
  </Card>
);
